const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';

const MESSAGING = {
    CREATE_CONTACT_FORM: `${API_BASE_URL}/messaging/create-form/`,
    CONTACT_FORM_INBOX: `${API_BASE_URL}/messaging/contact-form-inbox/`, 
    CONTACT_FORM_UNREAD: `${API_BASE_URL}/messaging/contact-form-unread-count/`, 
  };
  
  export default MESSAGING;